import { Button, Card, notification, Progress } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Decimal from "decimal.js-light";
import { createSet } from "../../firebase/fireStore";
import FirebaseApp from "../../firebase/context";

const CheckTask = () => {
  let history = useHistory();
  let location = useLocation();
  const { res } = location.state;
  const {
    task,
    emailPaciente,
    emailPsicologo,
    fechaCreada,
    namePaciente,
    namePsicologo,
  } = res.data;
  const [selectBtn, setSelectBtn] = useState("null");
  const [percentage, setPercentage] = useState(new Decimal(0));
  const progreso = () => {
    const number = new Decimal(1);
    const total = new Decimal((task || []).length);
    const verdaderas = new Decimal(
      (task || []).filter((item) => item.estado === true).length
    );
    const answer = verdaderas.mul(number).div(total).toNumber();
    const result = Number(answer).toFixed(2);
    setPercentage(result);
  };
  const UpdateList = async () => {
    const { data, isError, message } = await createSet(
      "Diagnostic",

      {
        emailPaciente: emailPaciente,
        emailPsicologo: emailPsicologo,
        fechaCreada: fechaCreada,
        fechaActualizada: FirebaseApp.firestore.Timestamp.fromDate(new Date()),
        namePaciente: namePaciente,
        task: task,
        percentage: percentage,
      },
      res.id
    );
    !isError
      ? console.log(data)
      : isError({
          message,
          show: true,
        });
  };
  const openNotification = () => {
    const key = `open${Date.now()}`;
    const btn = (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          UpdateList();
          notification.close(key);
          history.push("/tareas");
        }}
      >
        Enviar
      </Button>
    );
    notification.open({
      message: "Lista de tareas",
      description: `Enviar tarear realizadas al psicólogo`,
      btn,
      key,
      onClose: console.log("no"),
      placement: "top",
    });
  };
  useEffect(() => {
    progreso();
  }, [selectBtn]);

  return (
    <div>
      <div>Mi progreso</div>
      <Progress percent={percentage * 100} />
      <div>Actividades recomendadas por {namePsicologo}</div>
      <div>
        {task.map((res, index) => (
          <div>
            <Card
              key={index}
              style={{
                marginTop: "1%",
                backgroundColor: res.estado === true ? "#f4af1b" : "#ffffff",
                cursor: "pointer",
              }}
              onClick={() => {
                res.estado === null || res.estado === false
                  ? setSelectBtn((res.estado = true))
                  : setSelectBtn((res.estado = false));
              }}
            >
              {res.title}
            </Card>
          </div>
        ))}
      </div>
      <Button onClick={openNotification}>Enviar progreso</Button>
    </div>
  );
};

export default CheckTask;
